"use client";

import { ReactNode, useEffect, useRef } from "react";
import { handleBannerSlides } from "./service";
import { BannerSlide } from "@/components/common/banner/components/banner-slide";
import { cn } from "@/lib/utils";

export function Banner({
  campaigns = [],
  mobileCampaigns = [],
  className = "",
}: {
  campaigns: Array<BannerCampaignItem[]>;
  mobileCampaigns: Array<BannerCampaignItem[]>;
  className?: string;
}) {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!bannerRef.current) {
      return;
    }

    const desktop = bannerRef.current.querySelector(".banner-desktop");

    if (desktop) {
      desktop
        .querySelector(".banner-slide")
        ?.classList.add("banner-slide--active");
    }

    const interval = setInterval(() => {
      if (!bannerRef.current) {
        return;
      }

      if (bannerRef.current.classList.contains("banner--observed")) {
        clearInterval(interval);
      } else {
        handleBannerSlides();
      }
    }, 100);

    return () => clearInterval(interval);
  }, [bannerRef]);

  const bannerGroups = {
    desktop: campaigns,
    mobile: mobileCampaigns,
  } as const;

  if (mobileCampaigns.length === 0 && campaigns.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "banner-wrapper my-6",
        className,
        campaigns.length === 0 && "lg:hidden",
      )}
      ref={bannerRef}
    >
      {Object.keys(bannerGroups)
        .filter((groupKey) => bannerGroups[groupKey].length > 0)
        .map((groupKey) => (
          <div
            className={cn(
              "banner",
              "mx-auto flex items-center justify-center",
              groupKey === "desktop" &&
                mobileCampaigns.length > 0 &&
                "hidden md:flex",
              groupKey === "mobile" && "flex md:hidden",
              `banner-${groupKey}`,
            )}
            key={groupKey}
          >
            {
              Object.values(
                bannerGroups[groupKey as keyof typeof bannerGroups],
              ).map(
                (campaign, index) =>
                  campaign &&
                  Object.values(campaign).map((campaignItem, itemIndex) => (
                    <BannerSlide
                      defaultActive={index === 0 && itemIndex === 0}
                      key={itemIndex}
                      campaignItem={campaignItem}
                      campaignKey={index.toString()}
                      campaignItemKey={itemIndex.toString()}
                      width={parseInt(campaignItem.format.split("x")[0])}
                      height={parseInt(campaignItem.format.split("x")[1])}
                    />
                  )),
              ) as ReactNode
            }
          </div>
        ))}
    </div>
  );
}
